import 'edge/platform/base/module';
import 'edge/platform/map/module';

import GoogleMapsLocationData from './GoogleMapsLocationService';
import LocationSegmentationDirective from './LocationSegmentationDirective';

export default angular.module('edge.platform.segmentation.location', ['edge.platform.base', 'edge.platform.map'])
    .provider('gwLocationSegmentationService', GoogleMapsLocationData)
    .directive('gwLocationSegmentation', LocationSegmentationDirective);